import { render, staticRenderFns } from "./FileStorageLinkButton.vue?vue&type=template&id=b704f0c2&scoped=true&"
import script from "./FileStorageLinkButton.vue?vue&type=script&lang=js&"
export * from "./FileStorageLinkButton.vue?vue&type=script&lang=js&"
import style0 from "./FileStorageLinkButton.vue?vue&type=style&index=0&id=b704f0c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b704f0c2",
  null
  
)

export default component.exports